import cx from 'classnames'

import { builderLightText } from '@/blocks/utils'
import type { BackgroundColor, Space } from '@/components/Container'
import { Image } from '@/components/Image'
import type { TypographyColorModifier } from '@/components/Typography'
import type { TitleProps } from '@/models'

import type { BuilderImage } from '@/models/BuilderImage'

import Step, { type StepProps } from './Step'
import {
  MediaProductStepByStepBackground,
  MediaProductStepByStepContent,
  MediaProductStepByStepContainer,
  StepByStepContainer,
  MediaProductStepByStepTitle,
} from './styles'

interface MediaProductStepByStepProps {
  image?: BuilderImage
  title: TitleProps
  steps: StepProps[] | undefined
  background: BackgroundColor
  backgroundColor: string
  colorModifier: TypographyColorModifier
  space: Space
}

const MediaProductStepByStepBlock = ({
  image,
  title,
  steps,
  background,
  backgroundColor,
  colorModifier,
  space = 'm',
}: MediaProductStepByStepProps) => {
  const lightText = builderLightText(colorModifier)

  const backgroundProps = {
    style: {
      backgroundColor: (background === 'custom' && backgroundColor) || undefined,
    },
    className: cx({
      [`et-bg-${background}`]: background !== 'custom' && background,
    }),
  }

  const isThereAnyStep = steps && steps.length > 0

  return (
    <MediaProductStepByStepBackground
      {...backgroundProps}
      className={cx(backgroundProps.className, { [`eu-sm-${space}`]: space })}
    >
      <MediaProductStepByStepContainer>
        {image && (
          <Image
            source={image.url}
            alt={image.alt}
            aria-hidden={image['aria-hidden']}
            width={313}
            height={478}
          />
        )}
        <MediaProductStepByStepContent {...backgroundProps}>
          <MediaProductStepByStepTitle tag={title.tag || 'h3'} dark="high" light={lightText}>
            {title.text}
          </MediaProductStepByStepTitle>
          {isThereAnyStep && (
            <StepByStepContainer>
              {steps.map((step, index) => (
                <Step key={`mdp-step-${index}`} {...step} />
              ))}
            </StepByStepContainer>
          )}
        </MediaProductStepByStepContent>
      </MediaProductStepByStepContainer>
    </MediaProductStepByStepBackground>
  )
}
export default MediaProductStepByStepBlock
